import styled from 'styled-components';

export const ArticleFooterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 20px;
  justify-content: space-between;
  width: 100%;
`;

export const FooterItem = styled.span`
  cursor: pointer;
  align-items: center;
  display: flex;
`;
